import { useRecoilValue } from 'recoil';
import type { DoseProvenance } from '~/domain/projections/views';
import { useCurrentDoseView } from '~/hooks/dose/useCurrentDose';
import { doseOriginLabelOverrideState } from '~/state/atoms/dose/doseAtoms';
import { OverlayLabel } from '~/components/OverlayLabel';

const ORIGIN_LABEL: Record<DoseProvenance, string> = {
    predicted: 'AI Generated Dose',
    imported: 'Imported Dose',
    derived: 'Derived Dose, not saved',
};

// Names the origin of the dose in the colorwash overlay; a workflow may override the predicted label.
const DoseOriginLabel = () => {
    // The projection is undefined whenever no dose is selected, so this
    // single guard covers both "no dose" and "dose not yet resolvable".
    const doseData = useCurrentDoseView();
    // A workflow may rename a predicted dose it only carried, not generated.
    const override = useRecoilValue(doseOriginLabelOverrideState);

    if (!doseData) {
        return null;
    }

    const label =
        override && doseData.provenance === 'predicted'
            ? override
            : ORIGIN_LABEL[doseData.provenance];

    return <OverlayLabel data-testid="dose-origin-label">{label}</OverlayLabel>;
};

export default DoseOriginLabel;
